import { CapacitorHttp, type HttpOptions } from '@capacitor/core'

// Function to normalize headers for CapacitorHttp
const normalizeHeaders = (headers: HeadersInit | undefined): Record<string, string> => {
  if (!headers) return {}

  if (headers instanceof Headers) {
    const obj: Record<string, string> = {}
    headers.forEach((value, key) => {
      obj[key] = value
    })
    return obj
  }

  if (Array.isArray(headers)) {
    return Object.fromEntries(headers) // Convert tuple array to object
  }

  return headers // If already an object, return as is
}

// Custom fetch function for CapacitorHttp
export const capacitorFetch: typeof fetch = async (input: RequestInfo | URL | string, init?: RequestInit) => {
  const request: HttpOptions = {
    method: init?.method ?? 'POST',
    url: input as string,
    headers: normalizeHeaders({ ...init?.headers, Origin: window.location.origin }),
    data: init?.body ? (JSON.parse(init.body as string) as unknown) : undefined,
  }
  const response = await CapacitorHttp.request(request)

  return new Response(JSON.stringify(response.data), {
    status: response.status,
    headers: response.headers,
  })
}
